import { render, staticRenderFns } from "./ButtonLg.vue?vue&type=template&id=ae434e50&scoped=true"
import script from "./ButtonLg.vue?vue&type=script&lang=js"
export * from "./ButtonLg.vue?vue&type=script&lang=js"
import style0 from "./ButtonLg.vue?vue&type=style&index=0&id=ae434e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae434e50",
  null
  
)

export default component.exports